// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardChartCell_container__wi7SO","icon":"DashboardChartCell_icon__3hqYy","dummy":"DashboardChartCell_dummy__hlhjT"};